import { StoreType } from '@tock/shared/utils/connect';
import _ from 'lodash';

export const getPaymentCard = (state: StoreType) => state.paymentCard;
export const getCards = (state: StoreType) => {
  return {
    cards: _.uniqBy(_.filter(state.paymentCard.cards), 'storedToken'),
    isRequesting: state.paymentCard.listRequestInProgress,
    isInitialized: state.paymentCard.isInitialized,
  };
};
export const getDeviceData = (state: StoreType) => state.paymentCard.deviceData;
